import React from 'react'
import { Link } from 'react-router-dom'
import slider2 from '../../../../assets/img/slider2.webp'

function TicketSolution() {
  return (
    <>
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li>Ticketing Solution</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Ticketing <span>Solution</span></h2>
              <p>Q-Tickets is the no.1 ticketing platform in the Middle-East offering a complete range of ticketing services for cinemas, concerts, events, festivals, shows, sports tournaments, arts, theaters globally. Headquartered in Qatar, the company holds a strong presence across 6 countries and is a revolutionary one-stop solution provider to all things entertainment. </p>
              <p>Q-Tickets is the perfect ticketing solution for consumers who are looking for a comprehensive and secure system to purchase tickets online. With Q-Tickets, customers have the freedom to buy and manage tickets to any event, at any time, from anywhere. Customers can purchase tickets to concerts, sporting events, theater performances, and more with just a few clicks of the mouse. The company also offers customers the ability to manage their tickets and view event information with ease.</p>
              <p>Trailblazing innovations and going beyond ticketing, Q-Tickets has ventured into event production and continues to expand its operations, bringing the latest and most innovative ticketing and event management solutions within your reach.</p>
            </div> 
           <div className='hmslder-img'>
              <img src={slider2} alt='Ticketing Solution' width={1200} height={800} loading="lazy" />
            </div>  
        </div>
    </section>

    <section className='whu-sec'>
            <div className='container'>
                <div className='whu-sec1' style={{alignItems: "center"}}>
                    <div className='whulft'><img src={slider2} alt='Q-Tickets Mission and Vision' width={800} height={600} loading="lazy" /></div>
                    <div className='whurgt'>
                        <div className='ffr-desc' style={{ width: "100%" }}>
                            <h3>MISSION:</h3>
                            <p>Q-Tickets was founded with an assertive spirit and an earnest objective: to offer world-class ticketing services at revolutionary ease, and to everybody without boundaries, while leading the way for socially conscious and successful businesses.</p>
                            <h3>VISION:</h3>
                            <p>Ever since its conception 9 years ago, Q-Tickets has been in the forefront of event management and ticketing in the GCC. Hence our vision to become the world’s number-one ticketing and event management platform is only natural. Aiming higher, we also want to keep growing and expanding into uncharted regions, challenging our boundaries at every opportunity, come what may.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default TicketSolution
